import { Skeleton } from '@chakra-ui/react/skeleton';

import { FileViewerProps } from '../types/FileViewerProps';

const FileViewerSkeleton = ({ isAutoHeight, maxHeight }: Omit<FileViewerProps, 'language' | 'content'>) => {
  return <Skeleton width="100%" height={isAutoHeight ? `${maxHeight}px` : '100%'} />;
};

export default FileViewerSkeleton;
